import { createFileRoute } from '@tanstack/react-router';

import { HistoryPage } from '@/features/parent/HistoryPage';

export const Route = createFileRoute('/_authed/parent/history')({
  component: HistoryPage,
});
